import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { api } from 'api';
import { Divider } from 'antd';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { ScheduleActions, useActions, useAppSelector } from '@web-common/state/createStore';
import Left from './Left';
import Right from './Right';
import CreateScheduleBox from '../CreateBox/CreateBox';
import { getContanctObjs, initDefaultMoment } from '../CreateBox/util';
import { getCatalogList, getCatalogUnChecked, queryFreeBusyList } from '../../service';
import styles from './left.module.scss';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import busyIcon from '@/images/emoji/busy.png';
import freeIcon from '@/images/emoji/free.png';
import { ScheduleSyncObInitiator } from '../../data';
import scheduleTracker from '../../tracker';
import { getIn18Text } from 'api';
const sysApi = api.getSystemApi();
const eventApi = api.getEventApi();
const MODAL_WIDTH = 640;
const MODAL_HEIGHT = 600;
const isContactModule = () => location.hash.slice(1, 8) === 'contact';
const ScheduleModal = ({ user, showClose = true }) => {
    const rightRef = useRef(null);
    const actions = useActions(ScheduleActions);
    const [visible, setvisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedDay, setSelectedDay] = useState(moment());
    const [showBox, setShowbox] = useState(false);
    const [isBusy, setIsBusy] = useState(null);
    const [defaultContactList, setDefaultContactList] = useState(undefined);
    const { catalogList, unSelectedCatalogIds } = useAppSelector(state => state.scheduleReducer);
    useEffect(() => {
        getFreeBusy();
    }, [user]);
    useEffect(() => {
        let eid;
        if (visible) {
            getCataLoglist();
            eid = eventApi.registerSysEventObserver('syncSchedule', {
                func: e => {
                    if (e.eventStrData === ScheduleSyncObInitiator.MODAL_MODULE) {
                        e.eventData && SiriusMessage.success({ content: e.eventData.msg });
                        setLoading(true);
                    }
                },
            });
        }
        return () => {
            eventApi.unregisterSysEventObserver('syncSchedule', eid);
        };
    }, [visible]);
    const getCataLoglist = async () => {
        const catalogList = await getCatalogList();
        actions.updateCatlogList(catalogList);
        actions.updateUnSelectedCatalogIds(getCatalogUnChecked());
    };
    const getFreeBusy = () => {
        queryFreeBusyList({
            users: [user],
            start: moment().clone().subtract(15, 'minute').toDate(),
            end: moment().clone().add(15, 'minute').toDate(),
        }).then(res => {
            if (res[0] && res[0].freeBusyItems.length) {
                setIsBusy(true);
            }
            else {
                setIsBusy(false);
            }
        });
    };
    const addSchedule = async (isDirect, hour) => {
        var _a;
        const defaultMoment = initDefaultMoment(selectedDay);
        const creatDirectStartTime = defaultMoment.startTime;
        const creatDirectEndTime = defaultMoment.endTime;
        if (!isDirect) {
            creatDirectStartTime.hour(hour).minutes(0);
            creatDirectEndTime.hour(hour + 1).minutes(0);
        }
        const currentUser = (_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
        const users = [...new Set([user, currentUser])];
        const ContactList = await getContanctObjs(users);
        if (sysApi.isElectron()) {
            const initData = {
                catalogList,
                unSelectedCatalogIds,
                creatDirectStartTimeStr: creatDirectStartTime.format('YYYY-MM-DD HH:mm'),
                creatDirectEndTimeStr: creatDirectEndTime.format('YYYY-MM-DD HH:mm'),
                defaultContactList: ContactList,
                source: ScheduleSyncObInitiator.MODAL_MODULE,
            };
            sysApi.createWindowWithInitData('scheduleOpPage', { eventName: 'initPage', eventData: initData });
            setTimeout(() => {
                var _a;
                (_a = rightRef.current) === null || _a === void 0 ? void 0 : _a.resetTimeClick();
            }, 500);
        }
        else {
            actions.setCreatDirectStartTime(creatDirectStartTime);
            actions.setCreatDirectEndTime(creatDirectEndTime);
            setDefaultContactList(ContactList);
            setShowbox(true);
        }
    };
    const onCancel = () => {
        var _a;
        (_a = rightRef.current) === null || _a === void 0 ? void 0 : _a.resetTimeClick();
        setShowbox(false);
    };
    const onSyncCancel = () => {
        setLoading(true);
    };
    const onShow = event => {
        event.stopPropagation();
        setSelectedDay(moment());
        setvisible(true);
        scheduleTracker.scheduleContact({
            action: 'click',
            from: isContactModule() ? 'contact_detail' : 'contact_card',
        });
    };
    const onHide = event => {
        setvisible(false);
        event.stopPropagation();
    };
    useEffect(() => {
        scheduleTracker.scheduleContact({
            action: 'show',
            from: isContactModule() ? 'contact_detail' : 'contact_card',
        });
    }, [user]);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null,
            React.createElement("span", { onClick: onShow }, getIn18Text('CHAKANRICHENG')),
            isBusy !== null && (React.createElement("span", { className: styles.textNormal },
                React.createElement(Divider, { type: "vertical" }),
                React.createElement("img", { className: styles.busyFreeIcon, src: isBusy ? busyIcon : freeIcon, alt: "" }),
                isBusy ? getIn18Text('DANGQIANMANGLUZHONG') : getIn18Text('DANGQIANKONGXIANZHONG')))),
        React.createElement(Modal, { bodyStyle: { height: MODAL_HEIGHT, padding: 0, overflow: 'hidden' }, getContainer: () => document.body, maskStyle: { zIndex: 1030 }, wrapClassName: styles.scheduleModalWrap, footer: null, destroyOnClose: true, centered: true, closable: showClose, width: MODAL_WIDTH, visible: visible, onCancel: onHide },
            React.createElement("div", { className: "sirius-no-drag", style: { display: 'flex', height: '100%' }, onClick: e => {
                    e.stopPropagation();
                } },
                React.createElement(Left, { loading: loading, setLoading: setLoading, selectedDay: selectedDay, setSelectedDay: setSelectedDay, addSchedule: addSchedule }),
                React.createElement(Right, { ref: rightRef, loading: loading, setLoading: setLoading, selectedDay: selectedDay, setSelectedDay: setSelectedDay, addSchedule: addSchedule, user: user }),
                showBox && (React.createElement(CreateScheduleBox, { source: ScheduleSyncObInitiator.MODAL_MODULE, defaultContactList: defaultContactList, onCancel: onCancel, onSyncCancel: onSyncCancel, getReferenceElement: () => null }))))));
};
export default ScheduleModal;
